"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedtermsandconditions = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 52 60",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedtermsandconditions` : '') + (description ? ` desc-brandedtermsandconditions` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedtermsandconditions"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedtermsandconditions"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 3.6C0 1.63 1.53 0 3.41 0h25.06L42.7 12.6v43.8c0 1.98-1.53 3.6-3.41 3.6H3.4A3.51 3.51 0 0 1 0 56.4V3.6Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M42.7 12.64v-.04L28.49 0H3.42A3.51 3.51 0 0 0 .01 3.6v52.28c18.06-9.42 33-24.49 42.7-43.25Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M42.7 56.4V12.63C33 31.41 18.08 46.48 0 55.9v.51A3.5 3.5 0 0 0 3.41 60H39.3a3.51 3.51 0 0 0 3.41-3.6Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M28.47 0v9c0 1.99 1.53 3.6 3.41 3.6H42.7L28.47 0Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M23.74 16.3H9.17a.47.47 0 0 1-.46-.48c0-.27.2-.48.46-.48h14.57c.25 0 .45.21.45.48 0 .26-.2.47-.45.47Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M33.53 21.83H9.18a.47.47 0 0 1-.46-.48c0-.26.2-.47.46-.47h24.35c.24 0 .45.21.45.47 0 .27-.2.48-.45.48Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M33.53 27.37H9.18a.47.47 0 0 1-.46-.48c0-.26.2-.48.46-.48h24.35c.24 0 .45.22.45.48s-.2.48-.45.48Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M33.53 32.9H9.18a.47.47 0 0 1-.46-.47c0-.27.2-.48.46-.48h24.35c.24 0 .45.21.45.48 0 .26-.2.47-.45.47Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M33.53 38.8H9.18a.47.47 0 0 1-.46-.48c0-.27.2-.48.46-.48h24.35c.24 0 .45.21.45.48 0 .26-.2.47-.45.47Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M33.53 44.66H9.18a.47.47 0 0 1-.46-.48c0-.26.2-.47.46-.47h24.35c.24 0 .45.21.45.47s-.2.48-.45.48Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M51.06 6.48a.5.5 0 0 0-.22-.66L42.07 1.4a.46.46 0 0 0-.62.23L27.53 32.32a.51.51 0 0 0 .22.67l8.76 4.4c.24.13.52.02.63-.23L51.06 6.48Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m45.24 20.77.2-.44a1.85 1.85 0 0 1 2.51-.94l1.67-3.68c.4-.9.46-1.91.14-2.84l-.68-2.05 1.15-2.53 1.57 4.69c.31.93.26 1.95-.14 2.84l-2.98 6.57-.04.08a1.85 1.85 0 0 1-2.51.94 2.04 2.04 0 0 1-.89-2.65v.01Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M49.02 4.92 50 2.84a.5.5 0 0 0-.23-.67L45.67.18a.48.48 0 0 0-.64.24l-.98 2.08 4.97 2.42Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m35.73 37-3.5 4.45-4.8-2.42 1.09-5.67 7.2 3.64h.01Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M31.03 40.85 29.5 44.2a.47.47 0 0 1-.63.24l-1.55-.78a.5.5 0 0 1-.22-.66l1.52-3.34 2.4 1.21v-.02Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M49.58 2.17a.5.5 0 0 1 .22.66l-.95 2.08-2.47-1.24 1.15-2.54 2.04 1.04h.01Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M50.83 5.81a.5.5 0 0 1 .22.66L37.13 37.15a.44.44 0 0 1-.62.23l-4.45-2.24L46.38 3.57l4.45 2.24Z",
    fill: "#F26B1C"
  }));
};
var _default = exports.default = brandedtermsandconditions;